<template>
	<div class="token-stat-page">
		<el-card>
			<!-- 筛选区域 -->
			<el-form :model="form" inline label-width="80px">
				<el-form-item label="学校">
					<el-select v-model="form.schoolId" placeholder="请选择学校" @change="handleQuery">
						<el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id" />
					</el-select>
				</el-form-item>
				
				<el-form-item label="开始时间">
					<el-date-picker v-model="startDate" type="date" placeholder="选择起始时间"
						value-format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>
				<el-form-item label="结束时间">
					<el-date-picker v-model="endDate" type="date" placeholder="选择结束时间"
						value-format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleQuery">查询</el-button>
					<el-button @click="handleReset">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card style="margin-top:10px">
			<el-table :data="tableData" border stripe>
				<!-- <el-table-column label="学校ID" prop="schoolId" width="100" /> -->
				<el-table-column label="对话输入Token" prop="chatInput" />
				<el-table-column label="对话输出Token" prop="chatOutput" />
				<el-table-column label="对话总Token" prop="chatTotal" />
				<el-table-column label="作品输入Token" prop="workInput" />
				<el-table-column label="作品输出Token" prop="workOutput" />
				<el-table-column label="作品总Token" prop="workTotal" />
				<el-table-column label="总输入" prop="totalInput" />
				<el-table-column label="总输出" prop="totalOutput" />
				<el-table-column label="全部合计" prop="allTokenTotal" />
			</el-table>
		</el-card>
	</div>
</template>

<script>
	export default {
		name: 'TimeToken',
		data() {
			return {
				form: {
					schoolId: null
				},
				startDate: '',
				endDate: '',
				schoolList: [],
				tableData: [],
				semesterList:[],
				login:null,
			}
		},
		created() {
			this.fetchSchool()
		},
		methods: {
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			async fetchSchool() {
				if (localStorage.getItem('userType') == 2) {
					this.form.schoolId = localStorage.getItem('orgId')
					var name=localStorage.getItem('orgName')
					this.schoolList=[{id:this.form.schoolId,name:name}]
				}
				if(localStorage.getItem('semester')){
					this.semesterList=JSON.parse(localStorage.getItem('semester'))
					var arr=this.semesterList.filter(v=>v.status==1)[0]
					if(arr){
						this.startDate=this.tsToYmd(arr.startTime)
						this.endDate=this.tsToYmd(arr.endTime)
						this.handleQuery()
					}
				}
			},
			tsToYmd(ts) {
			  if (!ts) return ''
			  const d = new Date(ts)
			  const year = d.getFullYear()
			  const month = String(d.getMonth() + 1).padStart(2, '0')
			  const day = String(d.getDate()).padStart(2, '0')
			  return `${year}-${month}-${day}`
			},
			totime(val, type) {
				var time = new Date(val).getTime()
				if (type == 2) {
					time = time + 16 * 60 * 60 * 1000
				} else {
					time = time - 8 * 60 * 60 * 1000
				}
				return time
			},
			async handleQuery() {
				if (!this.form.schoolId || !this.startDate || !this.endDate) {
					this.$message.warning('请完善筛选条件')
					return
				}
				this.loginOpen('数据查询中...')
				try {
					const res = await this.API.get(this.API.fileurl.getschoolTokenTime, {
						schoolId: this.form.schoolId,
						startTime: this.totime(this.startDate),
						endTime: this.totime(this.endDate, 2),
					})
					this.tableData = res?.data?.data || []
				}catch(error){
					
				}finally{
					this.noLogin()
				}
			},

			handleReset() {
				this.form.schoolId = null
				this.startDate = ''
				this.endDate = ''
				this.tableData = []
			}
		}
	}
</script>